export const PUBLIC_ENVIRONMENT_LIST = "/api/environment/public/list";
export const ENVIRONMENT_DETAIL = "/api/environment/details";
export const ENVIRONMENT_LIST = "/api/resource/environment/list";
